import Button from '@material-ui/core/Button';
import { IBasicStyle } from './../../../../models/basic-style';
import { styled } from '@material-ui/core/styles';
import { CreateCSSProperties } from '@material-ui/core/styles/withStyles';

const containerStyles = (props: IBasicStyle): CreateCSSProperties => {
  return {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    minHeight: 65,
    minWidth: 50,
    border: '1px solid #D8D9E1',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    background: props.theme.palette.common.white,
  };
};

export const DashcardContainer = styled(Button)(containerStyles);
